<template>
  <div class="main" ref="main" v-loading="!showPage">
    <!-- <div ref="riskStatisticalChart3" style="width: 500px; height: 300px"></div> -->
    <template v-if="showPage">
      <template v-if="hData.hvalue >= 0">
        <div class="col1">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-row :gutter="10">
                <el-col :span="24" style="height: 418px">
                  <div class="card hValue" ref="hValue">
                    <div class="card-title">
                      <span class="card-title-icon"></span>
                      <span class="card-title-name">健康值信息</span>
                      <span class="card-title-detail" @click="checkDetail(8)"
                        >查看详情</span
                      >
                    </div>
                    <div
                      style="
                        height: 418px;
                        display: flex;
                        flex-direction: column;
                        padding: 0 20px;
                      "
                    >
                      <div class="item-hValue">
                        <!-- <m-circle-progress class="circlehValue" backgroundCircleColor="#D2D6DF" :progress="78"></m-circle-progress> -->
                        <!-- <circlehValue
                        class="circlehValue"
                        :pefectValue="hData.theoreticalHValue"
                        :targetValue="
                          $store.state.healthDocUser.isChannelArchive
                            ? hData.targetHValue
                            : 0
                        "
                        :progress="hData.hvalue"
                      ></circlehValue> -->
                        <circlehValue
                          class="circlehValue"
                          :pefectValue="hData.theoreticalHValue"
                          :progress="hData.hvalue"
                          :colorValue="colorValue"
                        ></circlehValue>
                      </div>
                      <p class="item-hValue-des">
                        超过
                        <span>{{ hData.percentageDistribution }}%</span>的同龄人
                      </p>
                      <p class="item-hValue-des1">
                        综合健康状态：
                        <span :style="{ color: colorValue }">{{
                          hData.userLevel
                        }}</span>
                      </p>
                      <p class="item-hValue-des1">
                        更新于
                        {{ new Date(hData.dateTime).getFullYear() }}年{{
                          new Date(hData.dateTime).getMonth() + 1
                        }}月
                      </p>
                      <p class="item-hValue-suggest">
                        {{ hData.userLevelExplain }}
                      </p>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="card hValue" ref="hAge">
                    <div class="card-title">
                      <span class="card-title-icon"></span>
                      <span class="card-title-name">健康年龄</span>
                    </div>
                    <div
                      style="
                        height: 418px;
                        display: flex;
                        flex-direction: column;
                        padding: 0 20px;
                      "
                    >
                      <div ref="hAgeChart" style="flex: 3; width: 100%"></div>
                      <div style="flex: 2; display: flex">
                        <div
                          style="
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            align-content: center;
                          "
                        >
                          <div
                            style="
                              font-size: 12px;
                              color: #999999;
                              text-align: justify;
                              padding: 8px 10px;
                              margin: 13px 8px 8px 8px;
                              background-color: rgba(0, 0, 0, 0.03);
                            "
                          >
                            {{ hData.hAgeExplain }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8">
              <el-row :gutter="10">
                <el-col :span="24">
                  <div class="card hValue" ref="hDengji">
                    <div class="card-title">
                      <span class="card-title-icon"></span>
                      <span class="card-title-name">健康维度</span>
                    </div>
                    <div
                      style="
                        height: 418px;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        padding: 0 20px;
                      "
                    >
                      <div ref="hweidu" style="flex: 5; width: 90%"></div>
                      <div style="flex: 3; width: 90%">
                        <div style="display: flex; flex-direction: column">
                          <div v-for="(a, b) in hData.dimensionList" :key="b">
                            <div
                              style="
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;
                                margin-bottom: 4px;
                                align-items: center;
                              "
                            >
                              <div class="wd-left">
                                <strong style="font-size: 14px">{{
                                  a.dimensionName.substring(0, 2)
                                }}</strong>
                                <p style="font-size: 13px">
                                  您的{{
                                    a.dimensionName.substring(0, 2)
                                  }}健康情况{{ a.score }}分
                                </p>
                              </div>
                              <div
                                class="wd-right"
                                :style="{
                                  color: getweiducolor(a.level),
                                  fontSize: '14px',
                                }"
                              >
                                {{ a.level }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="col2">
          <el-row :gutter="16">
            <el-col :span="16">
              <div class="card">
                <div class="card-title">
                  <span class="card-title-icon"></span>
                  <span class="card-title-name">疾病风险评估预警</span>
                  <span
                    class="card-title-detail"
                    v-if="diseaseRiskData && diseaseRiskData.length"
                    @click="checkDetail(4)"
                    >查看详情</span
                  >
                </div>
                <div class="riskStatistical">
                  <template v-if="diseaseRiskData && diseaseRiskData.length">
                    <div
                      class="riskStatisticalChart"
                      ref="riskStatisticalChart"
                    ></div>
                  </template>
                  <template v-else>
                    <div class="riskStatisticalEmpty" style="height: 380px">
                      <div class="riskStatisticalEmpty-center">
                        <img
                          class="riskStatisticalEmpty-icon"
                          src="../../../assets/images/hcalc2.png"
                          alt=""
                        />
                        <div class="riskStatisticalEmpty-text">
                          暂无疾病风险评估
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </el-col>
            <el-col :span="8">
              <template
                v-if="!this.$store.state.healthDocUser.isChannelArchive"
              >
                <div class="card risk" :style="{ height: hValueHeight + 'px' }">
                  <div class="card-title">
                    <span class="card-title-icon"></span>
                    <span class="card-title-name">风险因素</span>
                    <span
                      class="card-title-detail"
                      v-if="hData.riskFactorList && hData.riskFactorList.length"
                      @click="checkDetail(9)"
                      >查看详情</span
                    >
                  </div>
                  <div
                    class="riskStatistical"
                    :style="{
                      height: hValueHeight + 'px',
                    }"
                  >
                    <template
                      v-if="hData.riskFactorList && hData.riskFactorList.length"
                    >
                      <div
                        class="riskStatisticalChart1-1"
                        ref="riskStatisticalChart1"
                      ></div>
                    </template>
                    <template v-else>
                      <div class="riskStatistical2Empty" style="height: 360px">
                        <div class="riskStatistical2Empty-center">
                          <img
                            class="riskStatistical2Empty-icon"
                            src="../../../assets/images/hcalc1.png"
                            alt=""
                          />
                          <div class="riskStatistical2Empty-text">
                            风险因素未知
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="card risk" :style="{ height: hValueHeight + 'px' }">
                  <div class="card-title">
                    <span class="card-title-icon"></span>
                    <span class="card-title-name">风险因素</span>
                    <span
                      class="card-title-detail"
                      v-if="hData.riskFactorList && hData.riskFactorList.length"
                      @click="checkDetail(9)"
                      >查看详情</span
                    >
                  </div>
                  <div class="riskStatistical">
                    <template
                      v-if="hData.riskFactorList && hData.riskFactorList.length"
                    >
                      <div
                        class="riskStatisticalChart2"
                        ref="riskStatisticalChart2"
                      ></div>
                      <div
                        class="riskStatisticalChart1"
                        ref="riskStatisticalChart1"
                      ></div>
                    </template>
                    <template v-else>
                      <div class="riskStatistical2Empty">
                        <div class="riskStatistical2Empty-center">
                          <img
                            class="riskStatistical2Empty-icon"
                            src="../../../assets/images/hcalc1.png"
                            alt=""
                          />
                          <div class="riskStatistical2Empty-text">
                            风险因素未知
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </el-col>
          </el-row>
        </div>
        <div class="col4">
          <el-row :gutter="16">
            <el-col :span="24">
              <div class="card anomaly">
                <div class="card-title">
                  <span class="card-title-icon"></span>
                  <span class="card-title-name">异常指标预警</span>
                  <span
                    v-if="abnormalData && abnormalData.length"
                    class="card-title-detail"
                    @click="checkDetail(7)"
                    >查看详情</span
                  >
                </div>
                <div class="riskStatistical">
                  <template v-if="abnormalData && abnormalData.length">
                    <div
                      class="riskStatisticalChart4"
                      ref="riskStatisticalChart4"
                    ></div>
                  </template>
                  <template v-else>
                    <div class="riskStatisticalEmpty" style="height: 500px">
                      <div class="riskStatisticalEmpty-center">
                        <img
                          class="riskStatisticalEmpty-icon"
                          src="../../../assets/images/hcalc2.png"
                          alt=""
                        />
                        <div class="riskStatisticalEmpty-text">
                          暂无异常指标
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
      <template v-else>
        <div class="healthNonData">
          <img
            src="../../../assets/images/hcalc2.png"
            class="healthNonDataImage"
            alt=""
          />
          <div class="healthNonDataText">用户数据不完善，暂无评估结果</div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import {
  getPersionHValueDetail,
  getHealthHValue,
  getHRiskFactorIssue,
  getHealthUserAllDiseaseRisk,
  getHealthRiskEstimateList,
  getAbnormalWarning,
  getHealthUserAbnormalIndicatorStatisticsList,
  // getHDiseasePointHistoryList,
  getHealthDiseasePointHistoryList,
  // getMValueOutline
} from "../../../config/healthApi.js";
import circlehValue from "../../../components/health/circlehValue";
import mValueWave from "../../../components/health/mValueWave";
import { isEmpty, getYMDString, getYMDSimple } from "@/assets/js/until.js";
import mCircleProgress from "../../../components/health/mCircleProgress";

export default {
  name: "HealthAssessment",
  data() {
    return {
      hData: {
        hvalue: null,
      },
      showPage: false,
      riskFactorIssue: [],
      diseaseDirectionData: [],
      abnormalData: [],
      riskFactorData: [],
      diseaseRiskData: [],
      averageMValue: 0,
      mValueRecordList: [],
      hValueHeight: 0,
      // 环形七种颜色
      colorList: [
        "#A0523D",
        "#C36447",
        "#DB7957",
        "#F0A700",
        "#9ED500",
        "#40CF57",
        "#16D18D",
        // "#9B2800",
        // "#C53A09",
        // "#E85420",
        // "#F7B500",
        // "#E1E700",
        // "#A4D90F",
        // "#6DD400",
      ],
      textArray: ["极差", "很差", "较差", "一般", "较好", "很好", "极好"],
      colorValue: "",
    };
  },
  components: {
    circlehValue,
    mValueWave,
    mCircleProgress,
  },
  mounted() {
    this.getPersionHValueDetail();
  },
  methods: {
    getweiducolor(val) {
      return this.colorList[this.textArray.indexOf(val)];
    },
    // 健康年龄
    hAgeChart(age, hage) {
      let hAgeChart = this.$refs.hAgeChart;
      var myChart = this.$echarts.init(hAgeChart);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      var option = {
        xAxis: {
          type: "category",
          data: ["健康年龄", "实际年龄"],
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            // center: ["10%", "50%"],
            // radius: 90,
            data: [
              {
                value: hage,
                // itemStyle: {
                //   color: "#a90000",
                // },
              },
              {
                value: age,
                // itemStyle: {
                //   color: "#a90000",
                // },
              },
            ],
            type: "bar",
            barWidth: "20px",
            itemStyle: {
              color: function (params) {
                // params 是数据项的信息
                var colorList = [
                  "#7CE7AC",
                  "#0078fc",
                  "#91c7ae",
                  "#18D070",
                  "#2051F5",
                  "#FAD337",
                  "#d48265",
                  "#749f83",
                  "#ca8622",
                  "#bda29a",
                  "#61a0a8",
                ];
                return colorList[params.dataIndex];
              },
            },
            // itemStyle: {
            //   normal: {
            //     barWidth: "10px", // 这里设置柱状图的宽度为20px
            //     color: ["red", "blue"],
            //   },
            // },
          },
        ],
        grid: {
          left: "16%", // 设置左侧间距为容器宽度的 20%
          top: "20%",
          bottom: "10%",
          right: "10%",
          // 其他属性...
        },
      };
      myChart.setOption(option);
    },
    // 健康维度
    hweidu() {
      let hweidu = this.$refs.hweidu;
      var myChart = this.$echarts.init(hweidu);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      let value = [];
      this.hData.dimensionList.forEach((item) => {
        value.push(item.score);
      });
      var option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   left: "center",
        //   // data: ["A Software"],
        // },
        radar: [
          {
            shape: "circle",
            indicator: [
              { text: "心理", max: 1000 },
              { text: "身体", max: 1000 },
              { text: "行为", max: 1000 },
            ],
            center: ["50%", "60%"],
            radius: 100,
          },
        ],
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item",
            },
            areaStyle: {},
            data: [
              {
                value: value,
              },
            ],
            itemStyle: {
              color: function (params) {
                // params 是数据项的信息
                var colorList = [
                  // "#007AFF",
                  "#68b0ff",
                  "#85bfff",
                  "#bda29a",
                  "#61a0a8",
                  "#FAD337",
                  "#d48265",
                  "#2051F5",
                  "#18D070",
                  "#91c7ae",
                  "#36CBCB",
                ];
                return colorList[params.dataIndex];
              },
            },
          },
        ],
      };
      myChart.setOption(option);
    },
    checkDetail(e) {
      let name = "";
      if (e == 1) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "健康概述"
          : "健康概述D";
      } else if (e == 2) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "用户基本信息"
          : "用户基本信息D";
      } else if (e == 3) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "体检信息"
          : "体检信息D";
      } else if (e == 4) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "风险评估"
          : "风险评估D";
      } else if (e == 5) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "智能核保"
          : "智能核保D";
      } else if (e == 6) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "用户标签"
          : "用户标签D";
      } else if (e == 7) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "异常指标"
          : "异常指标D";
      } else if (e == 8) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "健康值信息"
          : "健康值信息D";
      } else if (e == 9) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "风险因素"
          : "风险因素D";
      } else if (e == 10) {
        name = !this.$store.state.healthDocUser.isDoc
          ? "疾病指向"
          : "疾病指向D";
      }
      this.$router.push({
        name: name,
        query: {
          userId: this.$store.state.healthDocUser.userId,
          type: this.$route.query.type,
        },
      });
    },
    checkAllDisease() {
      this.$router.push({
        name: "全部疾病指向",
        query: {},
      });
    },
    handleCheck(index, reportId) {
      this.$router.push({
        name: "体检报告审核页面详情单页",
        query: {
          reportIdKey: reportId,
          handleState: "check",
        },
      });
    },
    async getPersionHValueDetail() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthHValue({
          phoneNum: phone,
        });
      } else {
        data = await getPersionHValueDetail({
          userId: this.$store.state.healthDocUser.userId,
        });
      }

      if (data.code == 200) {
        let respondData = data.data;
        if (respondData.hValue == 0) {
          respondData.hValue = 10;
        }
        respondData.hvalue = respondData.hvalue || respondData.hValue;
        respondData.hage = respondData.hage || respondData.hAge;
        this.colorValue =
          this.colorList[this.textArray.indexOf(respondData.userLevel)];
        respondData.hageExplain =
          respondData.hAgeExplain || respondData.hageExplain;
        respondData.percentageDistribution =
          respondData.percentageDistribution ||
          respondData.distributionPercentage;
        respondData.percentageDistribution = respondData.percentageDistribution
          ? `${respondData.percentageDistribution}`
          : "0";
        if (!respondData.hvalue) {
          this.showPage = true;
          return;
        }
        if (!isEmpty(respondData.riskFactorList)) {
          let controlRiskList = [];
          let unControlRiskList = [];
          respondData.riskFactorList.forEach((item) => {
            if (item.hasControl) {
              controlRiskList.push(item);
            } else {
              unControlRiskList.push(item);
            }
          });
          respondData.controlRiskList = controlRiskList;
          respondData.unControlRiskList = unControlRiskList;

          respondData.riskFactorType = this.getRiskFactor(
            respondData.riskFactorList
          );
        }
        this.hData = respondData;
        this.showPage = true;
        // this.$store.state.healthDocUser.healthData = respondData;
        this.$nextTick(() => {
          // hValue
          let finalContainer = this.$refs.hValue.getBoundingClientRect();
          // this.hValueHeight = finalContainer.height;
          this.hValueHeight = 542;

          this.drawChart1();
          this.drawChart2();
          this.getHealthRiskEstimateList();
          // this.getHRiskFactorIssue();
          this.getAbnormalWarning();
          // this.getHDiseasePointHistoryList();

          if (this.$store.state.healthDocUser.isChannelArchive) {
            // this.getMValueOutline();
          }
          this.hAgeChart(respondData.age, respondData.hAge);
          this.hweidu();
        });
      } else {
        this.showPage = true;
      }
    },
    async getMValueOutline() {
      // profileId=937158233&appId=349701
      let data = null;
      // let profileid = this.$store.state.healthDocUser.profileId;
      // let appId = this.$store.state.healthDocUser.customerAppId;

      let profileid = 937158233;
      let appId = 349701;

      data = await getMValueOutline({
        profileId: profileid,
        appId: appId,
      });

      if (data.code == 0) {
        let respondData = data.data;
        this.mValueData = respondData;
        if (
          respondData &&
          respondData.mValueOutLine &&
          respondData.mValueOutLine.averageMValue
        ) {
          this.averageMValue = respondData.mValueOutLine.averageMValue;
        }
        if (
          respondData &&
          respondData.mValueRecordList &&
          respondData.mValueRecordList.length
        ) {
          this.mValueRecordList = respondData.mValueRecordList;
        }
        // this.mValueRecordList  = [{
        //   date: '2021-03-05',
        //   mValue: 80
        // }];
        this.$nextTick(() => {
          this.drawMValueChart(this.mValueRecordList);
        });
      }
    },
    async getHealthRiskEstimateList() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthUserAllDiseaseRisk({
          phoneNumber: phone,
        });
      } else {
        let profileid = this.$store.state.healthDocUser.profileId;
        let appId = this.$store.state.healthDocUser.customerAppId;
        data = await getHealthRiskEstimateList({
          userId: this.$store.state.healthDocUser.userId,
        });
      }

      if (data.code == 200) {
        data.data.forEach((a) => {
          a.rValueLevelList = a.rvalueLevelList;
        });
        let respondData = data.data;
        this.diseaseRiskData = respondData;
        this.$nextTick(() => {
          this.drawChart(respondData);
        });
      }
    },
    async getHRiskFactorIssue() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthUserAllDiseaseRisk({
          phoneNumber: phone,
        });
      } else {
        let profileid = this.$store.state.healthDocUser.profileId;
        let appId = this.$store.state.healthDocUser.customerAppId;
        data = await getHRiskFactorIssue({
          profileId: profileid,
          appId: appId,
        });
      }
      if (data.code == 200) {
        let riskFactorData = data.data;
        this.riskFactorData = riskFactorData;
        // this.$store.state.healthDocUser.healthRiskFactorData = riskFactorData;
        this.$nextTick(() => {
          this.drawChart1(riskFactorData);
        });
      }
    },
    async getAbnormalWarning() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getAbnormalWarning({
          phoneNumber: phone,
        });
      } else {
        data = await getAbnormalWarning({
          userId: this.$store.state.healthDocUser.userId,
        });
      }
      if (data.code == 1) {
        let abnormalData = data.data;
        // this.$store.state.healthDocUser.abnormalData = abnormalData;
        this.abnormalData = abnormalData;
        this.$nextTick(() => {
          this.drawChart4(abnormalData);
        });
      }
    },
    async getHDiseasePointHistoryList() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthDiseasePointHistoryList({
          phoneNumber: phone,
        });
      } else {
        let profileid = this.$store.state.healthDocUser.profileId;
        let appId = this.$store.state.healthDocUser.customerAppId;
        data = await getHDiseasePointHistoryList({
          userId: this.$store.state.healthDocUser.userId,
          profileId: profileid,
          appId: appId,
        });
      }
      if (data.code == 200) {
        let diseaseDirectionData = data.data;
        this.diseaseDirectionData = diseaseDirectionData;
        // this.$store.state.healthDocUser.diseaseDirectionData = diseaseDirectionData;
        this.$nextTick(() => {
          this.drawChart3(diseaseDirectionData);
        });
      }
    },
    getText(level) {
      if (level == 50) {
        return "风险极低";
      } else if (level == 100) {
        return "风险较低";
      } else if (level == 150) {
        return "风险一般";
      } else if (level == 200) {
        return "风险较高";
      } else if (level == 250) {
        return "风险极高";
      } else {
        return "未知";
      }
    },
    getValue(level) {
      if (level == "风险极低") {
        return 50;
      } else if (level == "风险较低") {
        return 100;
      } else if (level == "风险一般") {
        return 150;
      } else if (level == "风险较高") {
        return 200;
      } else if (level == "风险极高") {
        return 250;
      } else {
        return 0;
      }
    },
    getRiskFactor(respondData) {
      let riskFactor = [];

      let titles = [
        "生活方式",
        "指标监测",
        "人口学信息",
        "健康史",
        "家族史",
        "环境暴露史",
      ];

      titles.forEach((item, index) => {
        let item1 = {
          title: item,
          list: [],
        };
        riskFactor.push(item1);
      });

      respondData.forEach((item, index) => {
        item.selected = false;
        if (item.riskFactorType == "生活方式") {
          riskFactor[0].list.push(item);
        } else if (item.riskFactorType == "指标监测") {
          riskFactor[1].list.push(item);
        } else if (item.riskFactorType == "人口学信息") {
          riskFactor[2].list.push(item);
        } else if (item.riskFactorType == "健康史") {
          riskFactor[3].list.push(item);
        } else if (item.riskFactorType == "家族史") {
          riskFactor[4].list.push(item);
        } else if (item.riskFactorType == "环境暴露史") {
          riskFactor[5].list.push(item);
        }
      });

      return riskFactor;
    },
    drawChart(data) {
      console.log(123, data);
      if (!data.length) {
        return;
      }

      let diseaseGrades = ["", "极低", "较低", "一般", "较高", "极高", ""];
      // 疾病风险评估预警柱状图颜色
      var colors = ["#7CE7AC", "#5E81F4"];

      let echartData = [];
      let echartData1 = [];
      let xAxisData = [];
      let fabingbeishuList = [];
      let fabinglvList = [];
      data.forEach((item, index) => {
        fabinglvList.push((item.fallIllRate * 100).toFixed(0));
        fabingbeishuList.push(item.relativeRiskRate);
        if (item.riskLevelName != "已患" && item.riskLevelName != "风险未知") {
          let obj = {
            name: item.diseaseName,
            value: this.getValue(item.riskLevelName),
          };
          echartData.push(obj);
          xAxisData.push(item.diseaseName);

          let maxItem = item.rValueLevelList.find((item1, index) => {
            return (
              item.averagePersonRValue >= item1.startScore &&
              item.averagePersonRValue < item1.endScore
            );
          });
          let obj1 = {
            name: item.diseaseName,
            value: this.getValue(maxItem ? maxItem.level : null),
          };
          echartData1.push(obj1);
        }
      });
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart = this.$refs.riskStatisticalChart;
      var myChart = this.$echarts.init(riskStatisticalChart);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      let _this = this;
      let option = {
        color: colors,
        legend: {
          right: "20",
          top: "20",
          data: ["用户当前风险", "一般成年人风险", "发病概率", "发病倍数"],
        },
        tooltip: {
          trigger: "axis",
          // formatter: "{a0}: {a1}<br />{b0}: {b1}<br />{c0}: {c1}",
          formatter: function (params) {
            // console.log(params);
            return (
              params[0].seriesName +
              ":" +
              _this.getText(params[0].value) +
              "<br/>" +
              params[1].seriesName +
              ":" +
              _this.getText(params[1].value) +
              "<br/>" +
              params[2].seriesName +
              ":" +
              params[2].value +
              "<br/>" +
              params[3].seriesName +
              ":" +
              params[3].value
            );
          },
        },
        grid: {
          // top: '2%',
          left: "2%",
          right: "2%",
          bottom: "10%",
          containLabel: true,
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            // //网格样式
            // splitLine: {
            //     show: true,
            //     lineStyle:{
            //         color: ['#F7F7F7'],
            //         width: 1,
            //         type: 'solid'
            //     }
            // },
            axisLabel: {
              color: "#3B4859",
              fontSize: 12,
              rotate: 45,
            },
            type: "category",
            data: xAxisData,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            nameTextStyle: {
              color: "#666",
              fontSize: 13,
            },
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            //网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#F7F7F7"],
                width: 1,
                type: "solid",
              },
            },
            type: "value",
            name: "风险",
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              color: "#666",
              fontSize: 16,
              // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
              formatter: function (value, index) {
                return diseaseGrades[index];
              },
            },
          },
        ],
        series: [
          {
            name: "用户当前风险",
            type: "bar",
            barWidth: 8,
            data: echartData,
          },
          {
            name: "一般成年人风险",
            type: "bar",
            barWidth: 8,
            data: echartData1,
          },
          {
            name: "发病概率",
            type: "line",
            lineStyle: {
              width: 1,
            },
            data: fabinglvList,
            // [
            //   22.0, 22.2, 32.3, 42.5, 62.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0,26.2,
            // ]
          },
          {
            name: "发病倍数",
            type: "line",
            lineStyle: {
              width: 1,
            },
            data: fabingbeishuList,
            // data: [
            //   33.0, 33.2, 34.3, 35.5, 37.3, 31.2, 31.3, 34.4, 34.0, 37.5, 33.0,
            //   37.2,
            // ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    drawChart1() {
      if (!this.hData.riskFactorType || !this.hData.riskFactorType.length) {
        return;
      }
      let bgColor = "#fff";
      // let title = '总量';
      // let count = 234444;
      let colors = [
        "#5E81F4",
        "#7595ff",
        "#86A1F7",
        "#AEC0F9",
        "#D7DFFC",
        "#F1A28A",
        "#8BF1B9",
      ];
      let echartData = [];
      this.hData.riskFactorType.forEach((item, index) => {
        if (item.list.length) {
          let obj = {
            name: item.title,
            value: item.list.length,
          };
          echartData.push(obj);
        }
      });

      let allCount = echartData.length;
      echartData.forEach((item, index) => {
        item.percent = item.value / allCount;
      });

      let legendData = [];
      for (var j = 0; j < echartData.length; j++) {
        var data = {
          name: echartData[j].name,
          icon: "circle",
          textStyle: {
            fontSize: 18,
            color: colors[j],
          },
        };
        legendData.push(data);
      }
      let objData = this.array2obj(echartData, "name");
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart1 = this.$refs.riskStatisticalChart1;
      var myChart = this.$echarts.init(riskStatisticalChart1);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      let option = {
        backgroundColor: bgColor,
        color: colors,
        legend: {
          // orient: "h",
          bottom: "20",
          left: "center", /////////
          // right: "20",
          // right: "0",
          // top: "center",
          itemGap: 10,
          data: legendData,
          formatter: function (name) {
            return `{title|${name}}{value|${objData[name].value}个}`;
            // return `{title|${name}}{value|${objData[name].value}}{unit|个}`
          },
          textStyle: {
            rich: {
              title: {
                color: "#333333",
                fontSize: 16,
                width: 90,
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 0, 0, 0],
              },
              value: {
                color: "#333333",
                fontSize: 16,
                width: 20,
                align: "right",
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              // unit: {
              //     color: '#333333',
              //     fontSize: 16,
              //     // fontWeight: 600,
              //     // fontFamily: 'HuaKang',
              //     padding: [0, 0, 0, 0]
              // },
            },
          },
        },
        series: [
          {
            type: "pie",
            radius: ["0%", "40%"],
            center: ["50%", "30%"],
            data: echartData,
            hoverAnimation: true,
            itemStyle: {
              normal: {
                borderColor: bgColor,
                borderWidth: 0,
              },
            },
            // labelLine: {
            //     show: false,
            // },
            label: {
              // position: 'inside',
              formatter: function (params) {
                // return `{percent|${params.percent}}{unit|%}`
                return `${params.percent}%`;
              },
              // {unit|件}{percent|${objData[name].percent}}{unit|%}
              // formatter: params => {
              //     return (
              //         '{percent|' + objData[params.name].percent + '}{unit|%}'
              //     );
              // },
              // rich: {
              //     percent: {
              //         fontSize: 14,
              //         color: '#fff'
              //     },
              //     unit: {
              //         fontSize: 14,
              //         color: '#fff'
              //     }
              // }
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    drawChart2() {
      if (!this.hData.riskFactorList.length) {
        return;
      }

      let bgColor = "#fff";
      // let title = '总量';
      // let count = 234444;
      let colors = ["#FFAC21", "#678EFF"];
      let echartData = [
        {
          name: "可控",
          value: `${this.hData.controlRiskList.length}`,
          percent: `${
            this.hData.controlRiskList.length / this.hData.riskFactorList.length
          }`,
          label: "90",
        },
        {
          name: "不可控",
          value: `${this.hData.unControlRiskList.length}`,
          percent: `${
            this.hData.unControlRiskList.length /
            this.hData.riskFactorList.length
          }`,
          label: "90",
        },
      ];

      let legendData = [];
      for (var j = 0; j < echartData.length; j++) {
        var data = {
          name: echartData[j].name,
          icon: "rect",
          value: echartData[j].value,
          percent: echartData[j].percent,
          label: echartData[j].label,
          textStyle: {
            fontSize: 18,
            color: colors[j],
          },
        };
        legendData.push(data);
      }
      let objData = this.array2obj(echartData, "name");
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart2 = this.$refs.riskStatisticalChart2;
      let finalContainer =
        this.$refs.riskStatisticalChart2.getBoundingClientRect();

      if (!riskStatisticalChart2) {
        return;
      }
      var myChart = this.$echarts.init(riskStatisticalChart2);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      let option = {
        backgroundColor: bgColor,
        // color: colors,
        color: ["#7CE7AC", "#0078fc"],
        // title: [{
        //     text: '{name|' + title + '}\n{val|' + count + '}',
        //     top: 'center',
        //     left: '29%',
        //     textAlign: 'center',
        //     textStyle: {
        //         rich: {
        //             name: {
        //                 fontSize: 14,
        //                 fontWeight: 'normal',
        //                 color: '#666666',
        //                 padding: [10, 0]
        //             },
        //             val: {
        //                 fontSize: 14,
        //                 fontWeight: 'bold',
        //                 color: '#333333',
        //             }
        //         }
        //     }
        // }],
        legend: {
          // orient: "vertical",
          bottom: "10",
          left: "center", ////////
          // right: "0",
          // top: "center",
          itemGap: 10,
          data: legendData,
          formatter: function (name) {
            return `{title|${name}}{value|${objData[name].value}个}`;
          },
          textStyle: {
            rich: {
              title: {
                color: "#333333",
                fontSize: 16,
                width: 60,
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 0, 0, 0],
              },
              value: {
                color: "#333333",
                fontSize: 16,
                width: 20,
                align: "right",
                // fontWeight: 600,
                // fontFamily: 'HuaKang',
                padding: [0, 5, 0, 0],
              },
              //     unit: {
              //         color: '#333333',
              //         fontSize: 16,
              //         // fontWeight: 600,
              //         // fontFamily: 'HuaKang',
              //         padding: [0, 5, 0, 0]
              //     },
            },
          },
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "52%"],
            center: ["50%", "40%"],
            data: echartData,
            hoverAnimation: true,
            itemStyle: {
              normal: {
                borderColor: bgColor,
                borderWidth: 0,
              },
            },
            // labelLine: {
            //     show: false,
            // },
            label: {
              // position: 'inside',
              formatter: function (params) {
                // return `{percent|${params.percent}}{unit|%}`
                return `${params.percent}%`;
              },
              // {unit|件}{percent|${objData[name].percent}}{unit|%}
              // formatter: params => {
              //     return (
              //         '{percent|' + objData[params.name].percent + '}{unit|%}'
              //     );
              // },
              // rich: {
              //     percent: {
              //         fontSize: 14,
              //         color: 'red'
              //     },
              //     unit: {
              //         fontSize: 14,
              //         color: 'blue'
              //     }
              // }
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    textChangeLine(num, str) {
      // 判断文字的长度
      var strOrArr = "";
      if (str.indexOf("\n") !== -1) {
        // 如果文字描述里有换行符
        var strChange = str.split("\n");
        for (var i = 0; i < strChange.length; i++) {
          var strtr = strChange[i];
          var m = 0,
            k = m;
          var newArray1 = [];
          while (m < strtr.length) {
            m += num;
            newArray1.push([strtr.slice(k, m)]);
            k = m;
          }
          strOrArr += newArray1.join("\n");
          if (i !== strChange.length - 1) {
            // 不在最后一次循环加换行
            strOrArr += "\n";
          }
        }
      } else {
        // 如果文字描述里没有换行符
        var j = 0,
          o = j;
        var newArray2 = [];
        while (j < str.length) {
          j += num;
          newArray2.push([str.slice(o, j)]);
          o = j;
        }
        strOrArr = newArray2.join("\n");
      }
      return strOrArr;
    },
    getDrawColor(level) {
      // if (level == '其他') {
      //     return '86,180,22';
      // } else if (level == '轻度') {
      //     return '255,204,34';
      // }  else if (level == '中度') {
      //     return '252,140,65';
      // }  else if (level == '重度') {
      //     return '224,32,32';
      // }
      // return '86,180,22';

      if (level == "其他疾病") {
        return "86,180,22";
      } else if (level == "重疾前症") {
        return "252,140,65";
      } else if (level == "重疾") {
        return "224,32,32";
      }
      return "86,180,22";
    },
    getDrawIndex(level) {
      if (level == "其他" || level == "") {
        return 1;
      } else if (level == "轻度预警") {
        return 2;
      } else if (level == "中度预警") {
        return 3;
      } else if (level == "高度预警") {
        return 4;
      }
      return 0;
    },
    random(min, max) {
      return Math.random() < 0.5
        ? -1
        : 1 * (Math.floor(Math.random() * (max - min)) + min);
    },
    drawChart3(diseaseDirectionData) {
      let diseaseGrades = [
        "",
        "暂无预警数据",
        "轻度预警",
        "中度预警",
        "高度预警",
        "",
      ];
      //   var colors = ["rgba(86,180,22,0.10)", "#78B1F2", "#52BB6C"]
      let dataList = [];
      diseaseDirectionData.forEach((item, index) => {
        let newItem = {};
        newItem.month = getYMDSimple(item.dateTime);
        let list = [];
        let level1 = [];
        let level2 = [];
        let level3 = [];
        let level4 = [];
        1;
        item.diseasePointList.forEach((item1, index1) => {
          let newItem1 = {
            name: item1.diseasePointName,
            level: item1.diseaseLevel,
            warn: item1.earlyWarningLevel,
          };
          if (
            item1.earlyWarningLevel == "其他" ||
            item1.earlyWarningLevel == ""
          ) {
            level1.push(newItem1);
          } else if (item1.earlyWarningLevel == "轻度预警") {
            level2.push(newItem1);
          } else if (item1.earlyWarningLevel == "中度预警") {
            level3.push(newItem1);
          } else if (item1.earlyWarningLevel == "高度预警") {
            level4.push(newItem1);
          }
        });
        if (level1.length) {
          list.push({
            level: level1,
          });
        }
        if (level2.length) {
          list.push({
            level: level2,
          });
        }
        if (level3.length) {
          list.push({
            level: level3,
          });
        }
        if (level4.length) {
          list.push({
            level: level4,
          });
        }

        newItem.list = list;
        dataList.push(newItem);
      });

      var months = [""];
      var datas1 = [];
      for (var i = 0; i < dataList.length; i++) {
        let item = dataList[i];
        months.push(item.month);
        for (let j = 0; j < item.list.length; j++) {
          let item1 = item.list[j];
          for (let k = 0; k < item1.level.length; k++) {
            let item2 = item1.level[k];
            item2.name = this.textChangeLine(3, item2.name);
            // let x = 50*(i + 1) + (this.random(1,10));
            let x = 50 * (i + 1) + this.random(1, 2);
            if (item1.level.length == 1) {
            } else if (item1.level.length == 2) {
              if (k < 1) {
                x -= 5;
              } else {
                x += 5;
              }
            } else if (item1.level.length == 3) {
              if (k < 1) {
              } else if (k < 2) {
                x -= 5;
              } else {
                x += 5;
              }
            } else if (item1.level.length >= 4) {
              if (k % 2) {
                x -= 5;
              } else {
                x += 5;
              }
            }

            let y = this.getDrawIndex(item2.warn) * 50 + this.random(1, 5);
            if (item1.level.length == 1) {
            } else if (item1.level.length == 2) {
            } else if (item1.level.length == 3) {
              if (k < 1) {
                y += 15;
              } else {
                y -= 15;
              }
            } else if (item1.level.length >= 4) {
              if (k % 4 < 2) {
                y += 15;
              } else {
                y -= 15;
              }
            }

            datas1.push({
              ...item2,
              symbolSize: 52,
              value: [x, y],
              label: {
                normal: {
                  show: true,
                  formatter: "{b}",
                  color: `rgb(${this.getDrawColor(item2.level)})`,
                  textStyle: {
                    fontSize: "12",
                  },
                  // width: "50",
                  // //   height: '100',
                  // align: "center",
                  verticalAlign: "middle",
                  // rich: {
                  //   width: "50",
                  //   // height: '100',
                  //   color: "#fff",
                  // },
                },
              },
              itemStyle: {
                normal: {
                  color: `rgba(${this.getDrawColor(item2.level)},0.1)`,
                  borderColor: `rgba(${this.getDrawColor(item2.level)},0.4)`,
                  borderWidht: 2,
                  //   opacity: item.opacity
                },
              },
            });
          }
        }
      }
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart3 = this.$refs.riskStatisticalChart3;
      if (!riskStatisticalChart3) {
        return;
      }

      var myChart = this.$echarts.init(riskStatisticalChart3);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      if (months.length <= 5) {
        let option = {
          // color: colors,
          // legend: {
          //   right: "20",
          //   top: "20",
          //   data: ["重疾", "重疾前症", "其他疾病"],
          // },
          // dataZoom: {
          //     type: "inside",
          //     start: 0,
          //     disabled: true,
          //     end: 5/months.length*100,
          //     // end: months.length <= 5?100: 5/months.length*100,
          //     // startValue: 0,
          //     // endValue: 4,
          //     // minSpan: 0,
          //     // maxSpan: 60,
          //     // minValueSpan: 5,
          //     // maxValueSpan: 10,
          //     zoomLock: true,
          // },
          grid: {
            left: "4%",
            right: "4%",
            bottom: "6%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "value",
              axisLine: {
                lineStyle: {
                  color: "#F7F7F7",
                },
              },
              axisTick: {
                show: false,
              },
              //网格样式
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#F7F7F7"],
                  width: 1,
                  type: "solid",
                },
              },
              min: 0,
              max: months.length * 50,
              interval: 50,
              // offset: 50,
              axisLabel: {
                color: "#3B4859",
                fontSize: 12,
                // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                formatter: function (value, index) {
                  return months[index];
                },
              },

              // type: "category",
              // data: [
              //   "1月",
              //   "2月",
              //   "3月",
              //   "4月",
              // ],
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "疾病程度",
              nameTextStyle: {
                color: "#666",
                fontSize: 13,
              },
              axisLine: {
                lineStyle: {
                  color: "#F7F7F7",
                },
              },
              axisTick: {
                show: false,
              },
              //网格样式
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#F7F7F7"],
                  width: 1,
                  type: "solid",
                },
              },
              min: 0,
              max: 250,
              interval: 50,
              axisLabel: {
                color: "#666",
                fontSize: 16,
                // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                formatter: function (value, index) {
                  return diseaseGrades[index];
                },
              },
            },
          ],
          series: [
            {
              name: "重疾",
              type: "scatter",
              symbol: "circle",
              data: datas1,
            },
          ],
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      } else {
        let option = {
          // color: colors,
          // legend: {
          //   right: "20",
          //   top: "20",
          //   data: ["重疾", "重疾前症", "其他疾病"],
          // },
          dataZoom: {
            type: "inside",
            start: 0,
            end: (5 / months.length) * 100,
            // end: months.length <= 5?100: 5/months.length*100,
            // startValue: 0,
            // endValue: 4,
            // minSpan: 0,
            // maxSpan: 60,
            // minValueSpan: 5,
            // maxValueSpan: 10,
            zoomLock: true,
          },
          grid: {
            left: "4%",
            right: "4%",
            bottom: "6%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "value",
              axisLine: {
                lineStyle: {
                  color: "#F7F7F7",
                },
              },
              axisTick: {
                show: false,
              },
              //网格样式
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#F7F7F7"],
                  width: 1,
                  type: "solid",
                },
              },
              // min: 0,
              // max: months.length * 50,
              // interval: 50,
              // offset: 50,
              axisLabel: {
                color: "#3B4859",
                fontSize: 12,
                // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                formatter: function (value, index) {
                  return months[index];
                },
              },

              // type: "category",
              // data: [
              //   "1月",
              //   "2月",
              //   "3月",
              //   "4月",
              // ],
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "疾病程度",
              nameTextStyle: {
                color: "#666",
                fontSize: 13,
              },
              axisLine: {
                lineStyle: {
                  color: "#F7F7F7",
                },
              },
              axisTick: {
                show: false,
              },
              //网格样式
              splitLine: {
                show: true,
                lineStyle: {
                  color: ["#F7F7F7"],
                  width: 1,
                  type: "solid",
                },
              },
              min: 0,
              max: 250,
              interval: 50,
              axisLabel: {
                color: "#666",
                fontSize: 16,
                // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                formatter: function (value, index) {
                  return diseaseGrades[index];
                },
              },
            },
          ],
          series: [
            {
              name: "重疾",
              type: "scatter",
              symbol: "circle",
              data: datas1,
            },
          ],
        };
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
      }
    },
    drawChart4(data) {
      if (!data.length) {
        return;
      }
      let diseaseGrades = ["0", "5", "10", "15", "20及以上"];
      let colors = ["#7CE7AC", "#5E81F4", "#5E81F4"];
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let riskStatisticalChart4 = this.$refs.riskStatisticalChart4;
      if (!riskStatisticalChart4) {
        return;
      }

      var myChart = this.$echarts.init(riskStatisticalChart4);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      let xAxisData = [];
      let seriesData1 = [];
      let seriesData2 = [];
      let seriesData3 = [];
      let maxCount = 5;
      data.forEach((item, index) => {
        xAxisData.push(getYMDString(item.dateTime));
        seriesData1.push(item.important);
        seriesData2.push(item.common);
        item.total = item.common + item.important;
        seriesData3.push(item.total);
        let total = parseInt(item.total);
        if (total > maxCount) {
          maxCount = total;
        }
      });
      let option = {
        color: colors,
        legend: {
          right: "20",
          top: "20",
          data: ["重要指标", "一般指标", "总数"],
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "2%",
          containLabel: true,
        },
        dataZoom: {
          type: "inside",
          // start: 0,
          // end: 10,
          // startValue: 0,
          // endValue: xAxisData.length > 9? 9: xAxisData.length,

          startValue: xAxisData.length - 1 > 9 ? xAxisData.length - 1 - 9 : 0,
          endValue: xAxisData.length - 1,

          // minSpan: 10,
          // maxSpan: 50,
          // minValueSpan: 5,
          // maxValueSpan: 10,
          zoomLock: true,
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            // type: 'category',
            data: xAxisData,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              fontSize: 12,
              color: "#3B4859",
            },
          },
        ],
        yAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            //网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#F7F7F7"],
                width: 1,
                type: "solid",
              },
            },
            type: "value",
            name: "异常指标个数",
            nameTextStyle: {
              color: "#666",
              fontSize: 13,
            },
            min: 0,
            // max: maxCount,
            // interval: 1,
            minInterval: 1,
            splitNumber: 5,
            axisLabel: {
              color: "#666",
              fontSize: 16,
              // // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
              // formatter: function (value, index) {
              //   return diseaseGrades[index];
              // },
            },
          },
        ],
        series: [
          {
            name: "重要指标",
            type: "bar",
            barWidth: 12,
            label: {
              show: true,
              position: "top",
            },
            data: seriesData1,
          },
          {
            name: "一般指标",
            type: "bar",
            barWidth: 12,
            label: {
              show: true,
              position: "top",
            },
            data: seriesData2,
          },
          {
            name: "总数",
            type: "line",
            label: {
              show: true,
              position: "top",
            },
            data: seriesData3,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    drawMValueChart(data) {
      if (isEmpty(data)) {
        return;
      }

      let date = [];
      let chartData = [];
      data.forEach((item) => {
        // let month = getYMString(item.mValuemValue)
        date.push(item.date);
        chartData.push(item.mValue);
      });

      var colors = ["#7CE7AC"];

      // 基于准备好的dom，初始化echarts实例,绘制图表
      let mValueHistoryChart = this.$refs.mValueHistoryChart;

      if (!mValueHistoryChart) {
        return;
      }

      var myChart = this.$echarts.init(mValueHistoryChart);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
      // for (let index = 0; index <br 3; index++) {
      //     let month = index + '月';
      //     date.push(month);
      //     let aData = Math.floor(Math.random() * (200 - 10)) + 10;
      //     chartData.push(aData);
      // }
      let option = {
        color: colors,
        legend: {
          right: "20",
          top: "20",
          data: ["每日M值"],
        },
        tooltip: {
          trigger: "item",
          formatter(params) {
            let tip = `每日M值</br>${params.name}</br>${params.value}`;
            return tip;
          },
          show: true,
        },
        dataZoom: {
          type: "inside",
          // start: 0,
          // end: 10,
          // startValue: 0,
          // endValue: date.length > 10? 10: date.length,
          startValue: date.length - 1 > 11 ? date.length - 1 - 11 : 0,
          endValue: date.length - 1,
          // minSpan: 10,
          // maxSpan: 50,
          // minValueSpan: 5,
          // maxValueSpan: 10,
          zoomLock: true,
          // moveOnMouseWheel: true,
          // moveOnMouseMove: true,
          // moveOnMouseWheel: true,
          // preventDefaultMouseMove: true
        },
        grid: {
          left: "6%",
          right: "6%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "#F7F7F7",
            },
          },
          axisTick: {
            show: false,
          },
          boundaryGap: true,
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            color: "#3B4859",
            fontSize: 12,
            rotate: 45,
          },
          data: date,
        },
        yAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            //网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#F7F7F7"],
                width: 1,
                type: "solid",
              },
            },
            type: "value",
            name: "M值",
            nameTextStyle: {
              color: "#666",
              fontSize: 13,
            },
            // min: 0,
            // max: 1000,
            // interval: 200,
            axisLabel: {
              color: "#666",
              fontSize: 16,
              formatter: function (value, index) {
                if (index == 0) {
                  return "";
                }
                return value;
              },
            },
          },
        ],
        series: [
          {
            name: "每日M值",
            type: "line",
            symbol: "circle",
            symbolSize: 8,
            data: chartData,
            label: {
              show: true,
              position: "top",
              fontSize: 12,
              color: "#3B4859",
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    array2obj(array, key) {
      var resObj = {};
      for (var i = 0; i < array.length; i++) {
        resObj[array[i][key]] = array[i];
      }
      return resObj;
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  min-width: 1080px;
  padding-left: 16px;
  padding-right: 30px;
  /* padding: 100px 0; */
  overflow: scroll;
  position: relative;
  min-height: calc(100vh);
  background-color: #f5f6fa;
  overflow-x: hidden;
}

h1 {
  padding-top: 20px;
  color: #333333;
  // font-weight: bold;
  font-size: 16px;
}

.el-row .el-col {
  height: 100%;
}

.col1 {
  margin-top: 20px;
}

.card {
  position: relative;
  background-color: #fff;
  overflow: hidden;
}
.card-title {
  margin-top: 16px;
  height: 16px;
  position: relative;
}
.card-title-icon {
  background-color: #0062ff;
  display: inline-block;
  width: 4px;
  height: 14px;
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  left: 18px;
}
.card-title-name {
  margin-left: 0px;
  font-size: 16px;
  line-height: 16px;
  color: #3b4859;
  font-family: PingFangSC-Medium;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 30px;
}
.card-title-detail {
  font-size: 14px;
  line-height: 14px;
  color: #3381ff;
  font-family: PingFangSC-Medium;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  right: 18px;
  cursor: pointer;
}

.hValue {
  // width: 400px;
  // height: 410px;
  position: relative;
}

.item-hValue {
  //margin-top: 10px;
  height: 250px;
}

.circlehValue {
  margin: 0 auto;
  width: 100%;
  height: 250px;
}

.item-hValue-des {
  text-align: center;
  color: #666;
  font-size: 11px;
}

.item-hValue-des span {
  font-family: PingFangSC-Medium;
  color: #0078fc;
  font-size: 12px;
}

.item-hValue-des1 {
  text-align: center;
  color: #666;
  font-size: 11px;
}

.item-hValue-des1 span {
  font-family: PingFangSC-Medium;
  color: #0078fc;
  font-size: 14px;
}

.item-hValue-suggest {
  font-size: 12px;
  color: #999999;
  text-align: justify;
  padding: 8px 10px;
  margin: 13px 8px 8px 8px;
  background-color: rgba(0, 0, 0, 0.03);
  // position: absolute;
  // left: 0;
  // bottom: 0;
}

.healthAge {
  // height: 410px;
  position: relative;
}

.item-healthAge {
  margin: 50px 20% 0 20%;
  height: 215px;
  position: relative;
}

.item-healthAge-lastName {
  position: absolute;
  display: inline-block;
  width: 50%;
  text-align: center;
  left: 0px;
  bottom: 0px;
  font-size: 12px;
  color: #3b4859;
}
.item-healthAge-currentName {
  position: absolute;
  display: inline-block;
  width: 50%;
  text-align: center;
  right: 0px;
  bottom: 0px;
  font-size: 12px;
  color: #3b4859;
}

.item-healthAge-last {
  background-color: #7ce7ac;
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 200px;
  left: 25%;
  transform: translate(-50%);
  bottom: 20px;
}

.item-healthAge-current {
  background-color: #5e81f4;
  position: absolute;
  display: inline-block;
  width: 24px;
  height: 200px;
  right: 25%;
  transform: translate(50%);
  bottom: 20px;
}
.item-healthAge-lastValue {
  position: absolute;
  display: inline-block;
  width: 50%;
  text-align: center;
  left: 0rem;
  bottom: 170px;
  color: #3b4859;
  font-size: 13px;
}

.item-healthAge-currentValue {
  position: absolute;
  display: inline-block;
  width: 50%;
  text-align: center;
  right: 0rem;
  bottom: 120px;
  color: #3b4859;
  font-size: 13px;
}

.item-healthAge-suggest {
  font-size: 12px;
  color: #999999;
  text-align: justify;
  padding: 8px 10px;
  margin: 13px 8px 8px 8px;
  background-color: rgba(0, 0, 0, 0.03);
  position: absolute;
  left: 0;
  bottom: 0;
}

.m-wave {
  margin-top: 10px;
}

.mValueWave {
  margin: 0 auto;
  width: 100%;
  height: 250px;
}

.dieaseRisk {
  margin-top: 16px;
}

// .risk {
//   // height: 815px;
// }

.item-title {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 50px;
  line-height: 50px;
  background-color: lightgray;
}

.item-title-name {
  float: left;
  margin-left: 10px;
}

.item-title-des {
  float: right;
  margin-right: 10px;
  color: blue;
}

.col2 {
  margin-top: 20px;
}

.col2-item {
  background-color: #fff;
  border-radius: 10px;
}

.col3 {
  margin-top: 20px;
}

.col3-item {
  background-color: #fff;
  border-radius: 10px;
}

.col4 {
  margin-top: 16px;
  margin-bottom: 20px;
}

.col4-item {
  background-color: #fff;
  border-radius: 10px;
}

.riskStatistical {
  overflow: hidden;
  margin-top: 10px;
  background-color: #fff;
  position: relative;
  // display: flex;/////////
  justify-content: space-between;
  align-items: center;
  height: 500px;
}
.riskStatisticalChart {
  width: 100%;
  height: 100%;
}

.mValueHistoryChart {
  width: 100%;
  height: 100%;
}

.riskPrompt {
  font-size: 16px;
  margin-left: 20px;
}
.riskPrompt-value {
  color: red;
}

.riskStatisticalChart1 {
  // width: 50%;///////
  // height: 330px;/////
  height: 300px;
}

.riskStatisticalChart1-1 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;
}

.riskStatisticalChart2 {
  height: 200px;
}

.riskStatisticalChart1-2 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  height: 100%;
}

.riskStatisticalChart3 {
  margin-top: 20px;
  width: 100%;
  height: 600px;
}

.riskLegend-box {
  position: absolute;
  top: 60px;
  right: 20px;
  height: 20px;
}

.riskLegend {
  display: inline-block;
  margin-left: 20px;
}

.riskLegend-icon {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: #fff solid 1px;
  position: relative;
  top: 1px;
}

.riskLegend-text {
  font-size: 14px;
  color: #3b4859;
}

.riskLegend1-icon {
  background-color: rgba(224, 32, 32, 0.1);
  border-color: rgba(224, 32, 32, 0.4);
}

.riskLegend2-icon {
  background-color: rgba(252, 140, 65, 0.1);
  border-color: rgba(252, 140, 65, 0.4);
}

.riskLegend3-icon {
  background-color: rgba(86, 180, 22, 0.1);
  border-color: rgba(86, 180, 22, 0.4);
}

.riskStatisticalChart4 {
  width: 100%;
  height: 100%;
}

.table {
  margin: 20px;
}

.healthNonData {
  position: relative;
  // margin-top: 200px;
  height: 600px;
}

.healthNonDataImage {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.healthNonDataText {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #999999;
  text-align: center;
  position: absolute;
  left: 0px;
  bottom: 100px;
  // top: 50%;
  // transform: translateY(-50%,-50%);
}

.riskStatistical2Empty {
  margin-top: 20px;
  width: 100%;
  height: 805px;
  position: relative;
}

.riskStatistical2Empty-center {
  width: 200px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.riskStatistical2Empty-icon {
  width: 100%;
}

.riskStatistical2Empty-text {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: rgba(51, 51, 51, 0.2);
  letter-spacing: 0;
  text-align: center;
  line-height: 16px;
}

.riskStatisticalEmpty {
  margin-top: 20px;
  width: 100%;
  height: 600px;
  position: relative;
}

.riskStatisticalEmpty-center {
  width: 350px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.riskStatisticalEmpty-icon {
  width: 100%;
}

.riskStatisticalEmpty-text {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: rgba(51, 51, 51, 0.2);
  letter-spacing: 0;
  text-align: center;
  line-height: 16px;
}
</style>
